import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

import { IonTabs, IonTabBar, IonRouterOutlet, IonTabButton, IonIcon, IonModal, IonHeader, IonToolbar, IonContent, IonButton, IonButtons, IonAccordionGroup, IonAccordion, IonLabel, IonItem } from "@ionic/vue"
import { arrowBackCircleOutline, logOutOutline, menuOutline } from 'ionicons/icons';
import useAppTabs from './_inner/useAppTabs'
import useUserStore from "@/store/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTabs',
  setup(__props) {

const userStore = useUserStore();
const handleLogout = userStore.actions.logout

const {
    menu,
    isModalMenuOpen,
    openModalMenu,
    closeModalMenu,
    goBackRoute,
} = useAppTabs()


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonTabs), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRouterOutlet)),
        _createVNode(_unref(IonTabBar), { slot: "bottom" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonTabButton), {
              tab: "back",
              onClick: _unref(goBackRoute)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(arrowBackCircleOutline),
                  size: "large"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_unref(IonTabButton), {
              tab: "showMenu",
              onClick: _unref(openModalMenu)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(menuOutline),
                  size: "large"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_unref(IonTabButton), {
              tab: "logout",
              onClick: _unref(handleLogout)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(logOutOutline),
                  size: "large"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonModal), { "is-open": _unref(isModalMenuOpen) }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonToolbar), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButtons), { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(closeModalMenu)()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonContent), { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonAccordionGroup), { multiple: true }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).menuItemsGroups.value, (menuGroup) => {
                  return (_openBlock(), _createBlock(_unref(IonAccordion), {
                    key: menuGroup,
                    value: menuGroup
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), {
                        slot: "header",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "menu__item" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(menuGroup), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).menuItems.value[menuGroup], (menuItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${menuGroup}_${menuItem.label}`,
                          slot: "content"
                        }, [
                          _createVNode(_component_router_link, {
                            onClick: _unref(closeModalMenu),
                            to: menuItem.route,
                            class: "menu__itemInner"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(menuItem.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "to"])
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})